import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { currentLanguage } from "../../i18n";
import Header from "../../components/Header/Header";
import MissionSection from "../../components/MissionSection/MissionSection";
import FooterSection from "../../components/FooterSection/FooterSection";

const OurMission: React.FC = () => {
  const location = useLocation();
  const solutionsRef = useRef<HTMLDivElement>(null);
  const blogRef = useRef<HTMLDivElement>(null);
  const contactRef = useRef<HTMLDivElement>(null);
  const missionRef = useRef<HTMLDivElement>(null);
  const pressRef = useRef<HTMLDivElement>(null);
  const testimonialRef = useRef<HTMLDivElement>(null);
  const showcaseRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const currentPath = location.pathname;
    const currentHash = location.hash;

    if (!currentPath.match(/^\/[a-z]{2}(\/|$)/)) {
      const newPath = `/${currentLanguage}${currentPath === "/" ? "" : currentPath}${currentHash}`;
      window.history.replaceState(null, "", newPath);
    }
  }, [location.pathname, location.hash]);

  return (
    <div>
      <Header />
      <MissionSection />

      <FooterSection
        missionRef={missionRef}
        pressRef={pressRef}
        testimonialRef={testimonialRef}
        blogRef={blogRef}
        showcaseRef={showcaseRef}
        solutionsRef={solutionsRef}
        contactRef={contactRef}
      />
    </div>
  );
};
export default OurMission;
